const ITERATION_INTERVAL_MS = 250;
const CONTEXT_STATE = {
    RUNNING: 'running',
    SUSPENDED: 'suspended',
};
class ContextStateObserver {
    constructor(context, isInitial) {
        this.context = context;
        this.isInitial = isInitial;
        this.callbacks = {
            [CONTEXT_STATE.RUNNING]: [],
            [CONTEXT_STATE.SUSPENDED]: [],
        };

        context.onstatechange = () => {
            if (!this.callbacks[context.state]) {
                return;
            }
            this.callbacks[context.state].forEach((callback) => callback());
            if (isInitial && context.state === CONTEXT_STATE.RUNNING) {
                if (this.intervalId !== null) {
                    clearInterval(this.intervalId);
                    this.intervalId = null;
                }
                context.suspend();
            }
        };

        if (isInitial) {
            // State change is not triggered automatically (at least in chrome).
            // We have to call resume for the context to trigger a state change.
            this.intervalId = setInterval(() => {
                // In tests when running async code we crash here unless
                // we mock context properly. This is a bit lazy...
                if (!(context && context.resume)) {
                    return;
                }
                context.resume();
                // If the context is running, stop the polling. Audio is now initiated.
            }, ITERATION_INTERVAL_MS);
        }
    }
    addStateCallback(state, callback) {
        const { callbacks, context } = this;

        callbacks[state].push(callback);

        // If the anticipated state is already present, call the callback
        // right away to enable late subscribers.
        if (context.state === state) {
            callback();
        }

        return this;
    }

    onContextRunning(callback) {
        return this.addStateCallback(CONTEXT_STATE.RUNNING, callback);
    }

    onContextSuspended(callback) {
        return this.addStateCallback(CONTEXT_STATE.SUSPENDED, callback);
    }
}

export default ContextStateObserver;
